import { createCommonStore } from '@/store/index';

export enum CONTRACT_MODE {
  VIEW = 'view',
  SIGN = 'sign',
  ADD_ATTORNEY = 'add_attorney',
  EDIT_ATTORNEY = 'edit_attorney',
  DELETE_ATTORNEY = 'delete_attorney',
  MANAGE_ATTORNEYS = 'manage_attorneys',
}

interface ContractModalStore {
  mode: CONTRACT_MODE | null;
  setMode: (mode: CONTRACT_MODE | null) => void;
}

export const useContractModalStore = createCommonStore<ContractModalStore>(
  (set) => ({
    mode: null,
    setMode: (mode: CONTRACT_MODE | null) => set({ mode }),
  }),
  {
    name: 'contract-modal-store',
    storage: 'none',
  },
);
